import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LINE_ITEM_COUPON_DISCOUNT = 'line-item/coupon-discount';

/**
 * Renders the coupon discount line item with an optional remove button
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items
 * @param {boolean} props.isCustomer - Whether the user is the customer
 * @param {intlShape} props.intl - The intl object
 * @param {Function} props.onRemoveCoupon - Optional callback to remove the coupon (only on checkout page)
 * @returns {JSX.Element}
 */
const LineItemCouponDiscountMaybe = props => {
  const { lineItems, isCustomer, intl, onRemoveCoupon } = props;

  const couponLineItem = lineItems.find(
    item => item.code === LINE_ITEM_COUPON_DISCOUNT && !item.reversal
  );

  // Only show for customers who have the line item
  if (!couponLineItem || !isCustomer) {
    return null;
  }

  const formattedTotal = formatMoney(intl, couponLineItem.lineTotal);

  return (
    <div className={css.lineItem} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.couponDiscount" />
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {onRemoveCoupon ? (
          <button
            type="button"
            onClick={onRemoveCoupon}
            style={{
              background: 'none',
              border: 'none',
              color: '#6b7280',
              cursor: 'pointer',
              fontSize: '12px',
              textDecoration: 'underline',
              padding: '0'
            }}
            title="Remove coupon"
          >
            <FormattedMessage id="OrderBreakdown.removeCoupon" />
          </button>
        ) : null}
        <span className={css.itemValue} style={{ color: '#dc2626' }}>
          {formattedTotal}
        </span>
      </div>
    </div>
  );
};

export default LineItemCouponDiscountMaybe;
